import {FilterBase} from 'core-lib';
import {ListViewModelBase} from 'core-lib';

export class AdminListViewModel extends ListViewModelBase {

    public permitNo: string;
    public abn: string;
    public businessName: string;

    constructor() {
        super();
        this.items = [];
        this.filter = new AdminListFilter();
    }

    public filter: AdminListFilter;
    public items: AdminListItem[];
}

export class AdminListItem {
    public userId: number;
    public userName: string;
    public fullName: string;
    public email: string;
    public roles: string[];
    public status: string;
}

export class AdminListFilter extends FilterBase {

}